import React from 'react'

//Node Modules 
import { useTranslation } from 'react-i18next'

//Components
import Divider from 'components/Divider'
import LinkButton from 'components/LinkButton'

//Styles
import styles from './DownloadContainer.module.scss'

interface Props{
  selectAll: () => void,
  unselectAll: () => void
}

const Multiselector = ({selectAll, unselectAll}: Props) => { 

  const { t } = useTranslation()
  return (
    <div className={styles.multiselect}>
      <Divider variant="light">
        <LinkButton className = {styles.linkButton} onClick={selectAll}>
          {t("helpcenter-gui-icu.downloadpage.fileselector.select_all.label")}       
        </LinkButton>
        <LinkButton className={styles.linkButton} onClick={unselectAll}>
          {t("helpcenter-gui-icu.downloadpage.fileselector.unselect_all.label")}
        </LinkButton>
      </Divider>
    </div>
  )
}

export default Multiselector